import React, { memo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { DTMF_KEYS } from '../../MobileCallSurface.constants';
import { dtmfGridStyles } from '../../MobileCallSurface.styles';

import DtmfKey from './components/DtmfKey';

const DtmfPad = ({ onDigitPress }) => (
  <Box sx={dtmfGridStyles}>
    {DTMF_KEYS.map(digit => (
      <DtmfKey digit={digit} key={digit} onPress={onDigitPress} />
    ))}
  </Box>
);

DtmfPad.propTypes = {
  onDigitPress: PropTypes.func.isRequired,
};

export default memo(DtmfPad);
